export default __webpack_public_path__ + "static/media/pencil.a9e27262.svg";